import DropDown from "@/components/supportDropdown/supportDropdown.vue";
import { HelpService } from "@/services/helpApi";
import { createNamespacedHelpers } from "vuex";

const { mapGetters: userGetters } = createNamespacedHelpers("user");
const labels = [
	// eslint-disable-line one-var
	"support.technical_problems_with_the_hardware",
	"support.technical_problems_with_the_dashboard",
	"support.data_is_not_loading",
	"support.mistake_in_the_data",
	"support.request_more_images",
	"support.other",
];

export default {
	mounted() {
		const label = `support.${this.$route.query.label}`;
		// eslint-disable-next-line object-curly-newline
		this.selectedItem = labels.indexOf(label) >= 0 ? { label: this.$t(label) } : null;
		if (this.selectedItem) this.$refs.dropdown.select(this.selectedItem);
	},

	components: { DropDown },

	data() {
		return {
			// dropdown
			// eslint-disable-next-line object-curly-newline
			dropDownItems: labels.map((label) => ({ label })),
			// { label: string }
			selectedItem: this.selectedItem,
			// message
			message: "",
			isSending: false,
			isEmailSend: false,
		};
	},

	computed: {
		translatedItems,
		...userGetters(["activeOutlet", "user"]),
	},

	methods: {
		onDropdownSelect,
		send,
	},
};

async function send() {
	this.isSending = true;

	try {
		const subject = "[SUPPORT] " + this.selectedItem.label + " - " + this.activeOutlet.outlet_name,
			message = this.message + "\n\nRequested by " + this.user.firstName + " " + this.user.lastName;
		await HelpService.sendSupportEmail(subject, message);
		this.message = "";
		this.isEmailSend = true;
	} catch (error) {
		this.$swal({
			title: this.$t("auth.attention"),
			text: this.$t("error.please_try_again"),
			type: "error",
			confirmButtonText: this.$t("auth.ok"),
		});
	} finally {
		this.isSending = false;
	}
}

function translatedItems() {
	return this.dropDownItems.map((item) => {
		item.label = this.$t(item.label);
		return item;
	});
}

function onDropdownSelect(item) {
	this.selectedItem = item;
}
